
<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">{{ artist.stage_name }}</h1>
        </div>
        <nav aria-label="breadcrumb" class="wow fadeInDown" data-wow-duration="1.5s">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/client/talents">Our talent</a></li>
                <li v-if="artist.categories && artist.categories.length" class="breadcrumb-item">
                    <a :href="`/client/talents/category/${artist.categories[0].id}`">
                        {{ artist.categories[0].name }}
                    </a>
                </li>
                <li class="breadcrumb-item">
                    <a :href="`/artist/${ artistId }/show`">
                        {{ artist.stage_name }}
                    </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Testimonials</li>
            </ol>
        </nav>
        <h2 class="title text-center wow zoomIn" data-wow-duration="1.5s"><strong>Testimonials</strong></h2>
        <ul class="testimonials">
            <li
                class="testimonials__item wow zoomIn"
                data-wow-duration="1.5s"
                v-for="testimonial in listOfTestimonials"
                :key="testimonial.id"
            >
                <div class="testimonials__sep" aria-hidden="true">
                    <span></span>
                    <img src="/img/quote.png" alt="" width="42">
                    <span></span>
                </div>
                <p class="testimonials__text"> {{testimonial.quote_description}}</p>
                <span class="testimonials__author">- <strong> {{testimonial.author_name }}</strong>, {{testimonial.quote_resource }} -</span>
            </li>

        </ul>
    </div>
</template>

<script>
import ClientService from "../../services/ClientService";

export default {
    name: 'ArtistTestimonials',
    props: {
        artistId: {
            type: String | Number
        }
    },
    data() {
        return {
            listOfTestimonials: [],
            artist: Object
        }
    },
    mounted() {
        this.getListOfArtistTestimonials()
    },

    methods: {
        async getListOfArtistTestimonials() {
            try {
                const { data: response } = await ClientService.getArtistTestimonials(this.artistId)
                this.listOfTestimonials = response.quotes

                const { data: artistResponse} = await ClientService.getArtistInnerInfo(this.artistId)
                this.artist = artistResponse
                console.log(this.artist)
            } catch {

            }
        }
    }
}

</script>


<style scoped>

</style>
